
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { createApp, defineAsyncComponent } from 'vue';
import { ZiggyVue, route } from '../../../vendor/tightenco/ziggy/dist';
import { Ziggy } from './ziggy';

import Alpine from 'alpinejs';
window.Alpine = Alpine;
document.addEventListener('DOMContentLoaded', () => Alpine.start());

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const DonationCollection = defineAsyncComponent(() => import('./vue/accounts/donations/DonationCollection.vue'));
const FeesCollection = defineAsyncComponent(() => import('./vue/fees/collections/FeesCollection'));
const CreateAccountRecords = defineAsyncComponent(() => import('./vue/accounts/records/CreateAccountRecords'));
const AddEditInvoice = defineAsyncComponent(() => import('./vue/accounts/billing/AddEditInvoice'));
const AddEditEximusInvoice = defineAsyncComponent(() => import('./vue/accounts/billing/AddEditEximusInvoice'));
const CreateExamRecord = defineAsyncComponent(() => import('./vue/academics/exams/records/CreateExamRecord'));
const LessonEvaluationRecord = defineAsyncComponent(() => import('./vue/academics/lesson-evaluations/LessonEvaluationRecord'));
const EditEmployeeShifts = defineAsyncComponent(() => import('./vue/hr/attendance/employee-shifts/EditEmployeeShifts'));
const AddPurchase = defineAsyncComponent(() => import('./vue/inventory/purchases/AddPurchase.vue'));
const CreateMcq = defineAsyncComponent(() => import('./vue/academics/mcq/CreateMcq.vue'));
const CreateSurvey = defineAsyncComponent(() => import('./vue/branch-performance/CreateMcq.vue'));
const OnlineApplicationHscForm = defineAsyncComponent(() => import('./vue/hr/online-application-hsc/OnlineApplicationHscForm'));
const CreateDailyLessons = defineAsyncComponent(() => import('./vue/academics/daily-lessons/CreateDailyLessons.vue'));
const StudentCounts = defineAsyncComponent(() => import('./vue/hr/students/StudentCounts.vue'));
const AttendanceDeviceInstanceDetails = defineAsyncComponent(() => import('./vue/attendance-devices/AttendanceDeviceInstanceDetails.vue'));
const AttendanceDeviceDetails = defineAsyncComponent(() => import('./vue/attendance-devices/AttendanceDeviceDetails.vue'));
const CreateCustomForm = defineAsyncComponent(() => import('./vue/components/CreateCustomForm.vue'));
const CreateCustomFormSubmission = defineAsyncComponent(() => import('./vue/components/CreateCustomFormSubmission.vue'));
const AssignPermissions = defineAsyncComponent(() => import('./vue/hr/users/AssignPermissions.vue'));
const ShowSiblingsWaiverPreview = defineAsyncComponent(() => import('./vue/siblings/ShowSiblingsWaiverPreview.vue'));

window.app = createApp({
    components: {
        DonationCollection,
        FeesCollection,
        CreateAccountRecords,
        AddEditInvoice,
        AddEditEximusInvoice,
        CreateExamRecord,
        LessonEvaluationRecord,
        EditEmployeeShifts,
        AddPurchase,
        CreateMcq,
        OnlineApplicationHscForm,
        CreateDailyLessons,
        StudentCounts,
        AttendanceDeviceInstanceDetails,
        AttendanceDeviceDetails,
        CreateCustomForm,
        CreateCustomFormSubmission,
        AssignPermissions,
        ShowSiblingsWaiverPreview,
        CreateSurvey,
    }
}).use(ZiggyVue, Ziggy);

// Make window object available to all components as global property
app.config.globalProperties.window = window;

window.route = (routeName, params) => route(routeName, params, null, Ziggy);

require('./main');

document.addEventListener('DOMContentLoaded', () => {
    window.editor.render()
});
